<div class="message chat-info chat-status"
     data-isodate="{{{o.isodate}}}"
     data-status="{{{o.from}}}">{{{o.message}}}</div>
